import styled from 'styled-components';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { Navigate } from 'react-router-dom';
import { loginRequest } from '../config/authConfig';
import { HOME } from '../config/routes';
import logoSrc from '../assets/images/se-logo.png';
import bgSrc from '../assets/images/bg-img-01.jpg';

const PageOverlay = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  background: url(${bgSrc}) no-repeat center center fixed;
  background-size: cover;
  min-height: 100vh;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  position: relative;
  flex: 1 0 auto;
  padding: 16px;

  @media (min-width: 576px) {
    padding: 32px;
  }
`;

const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 528px;
  padding: 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.heading_dark};

  @media (min-width: 576px) {
    padding: 48px;
  }
`;

const Title = styled.h1`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1.25;
  margin: 0;
  margin: 1rem 0;
`;

const Logo = styled.img`
  margin: 0 auto;
  display: block;
  width: 77px;
  height: auto;
  margin-bottom: 32px;
`;

const LinkBtn = styled.button`
  display: inline;
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
  color: ${({ theme }) => theme.colors.information};

  &:hover {
    color: ${({ theme }) => theme.colors.information_bg};
  }
`;

function LoginPage() {
  // const [error, setError] = useState<any | null>(null);
  const isAuthenticated: boolean = useIsAuthenticated();
  const { inProgress, instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      // setError(e);
      // eslint-disable-next-line
      console.error('Login ERROR: ', e);
    });
  };

  if (inProgress !== InteractionStatus.None) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to={HOME} replace />;
  }

  return (
    <PageOverlay>
      <Wrapper>
        <ContentWrapper className="se-tile se-tile--shadow">
          <Logo src={logoSrc} alt="The renewable materials company" width="77" height="93" />
          <Title>Energy Monitoring tool</Title>
          <p>
            You are not logged in, please{' '}
            <LinkBtn type="button" onClick={handleLogin}>
              sign-in
            </LinkBtn>{' '}
            to use the application.
          </p>
        </ContentWrapper>
      </Wrapper>
    </PageOverlay>
  );
}

export default LoginPage;
